export default __webpack_public_path__ + "static/transaction-page-accepted-ba0446303e0460d0171e45575a512f6f.png";